import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, tap, switchMap } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import { CreditService } from '../../services/credit.service';
import { GlobalsService } from '../../services/globals.service';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common'

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from 'app/services/users.service';
import { OmsService } from 'app/services/oms.service';

@Component({
	selector: 'app-open-credits',
	templateUrl: './open-credits.component.html',
	styleUrls: ['./open-credits.component.scss']
})

export class OpenCreditsComponent implements OnInit, OnDestroy {

	@Input() customerdata: any = [];
	@Input() item: any = false;
	@Input() lookingfor: any = false;
	@Output() cart_updated = new EventEmitter < string > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() cancel = new EventEmitter < boolean > ();
	@Output() credit_data = new EventEmitter < any > ();


	searchInput = new UntypedFormControl('');
	searchInputItems = new UntypedFormControl('');
	defaultlocation = new UntypedFormControl('');
	order_status_edit = new UntypedFormControl('');
	order_statuses: any = false;
	openorders: any = [];
	customertrans: any = [];
	filteredItems: any = [];
	headercolumns: string[] = [
		'orderno',
		'statusname',
		'deliverydate',
		'from_order',
		'customer',
		'deliverto',
		'ponumber',
		'phoneno',
		'email',
		'totals'
	];

	orderupdates: any = [];
	openOrderData: any = [];
	allopenOrderData: any = [];
	config: any = [];
	pickinglink = '';
	orderdetails: any = [];
	locations: any = [];

	itemsearchresults: any = [];
	itemsearch = false;
	user: any = false;
	ref_location: any = false;
	returnSheetLink: any = '';
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	orderMatches: any = [];

	private readonly destroy$ = new Subject<void>();
	private dataLoadSub: Subscription | null = null;

	constructor(private omsService:OmsService,  private usersService:UsersService, public creditService: CreditService, public globalSearchService: GlobalSearchService, public router: Router, public customerService: CustomerService, private location: Location, private globalsService: GlobalsService, private modalService: NgbModal) {
		this.config = this.globalsService.getApiConfig();

		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.creditPickingLink;
		this.returnSheetLink = this.config.apiServer.baseUrl + this.config.apiServer.returnSheetLink;

	}

	ngOnInit(): void {
		this.globalSearchService.locations
			.pipe(takeUntil(this.destroy$))
			.subscribe((results: any) => {
				this.locations = results;
				if (results?.length) {
					this.defaultlocation.setValue(results[0].loccode);
				}
			});

		this.creditService
			.getOrderStatuses()
			.pipe(
				tap((r: any) => {
					this.order_statuses = r;
				}),
				switchMap(() => this.globalSearchService.user),
				takeUntil(this.destroy$)
			)
			.subscribe((results) => {
				if (this.user) {
					if (results.user.defaultlocation.loccode != this.ref_location) {
						this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
						this.loadData();
						this.ref_location = false;
					}
				}

				this.user = results;
				if (!this.ref_location) {
					this.ref_location = this.user.user.defaultlocation.loccode;
				}
			});
	}

	ngOnDestroy(): void {
		this.dataLoadSub?.unsubscribe();
		this.dataLoadSub = null;
		this.destroy$.next();
		this.destroy$.complete();
	}

	openModal(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	search() {
		this.itemsearch = false;
		const value = this.searchInput.value;
		if (value && value != '') {
			this.openorders = this.globalSearchService.filterItem(this.openOrderData, value, 'orderno,transno,ponumber,debtorno,deliverto,deliverydate,stockid,description');

			this.openorders = new MatTableDataSource(this.openorders);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;

		} else {
			this.openOrderData = this.allopenOrderData
			this.openorders = new MatTableDataSource(this.allopenOrderData);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;
		}
	}

	getTotal(totals: any) {
		if(totals) {
			const total= totals.filter( r => {
				if(r.code) {
					return r.code == 'total'
				}
			})[0];
			if(total) {
				return total.text
			}
		}

		return 0.00;

	}

	searchItems() {
		const value = this.searchInputItems.value;

		if (value && value != '') {
			this.itemsearch = true;
			const searchdata = [];
			this.openOrderData.forEach((item: any) => {
				searchdata.push(item.details)
			});

			const searchresults = this.globalSearchService.filterItem(searchdata, value, 'orderno,narrative,stkcode,description,ordervalue');
			const mapped = searchresults.map(i => i.orderno);

			this.itemsearchresults = searchresults;

			this.openorders = this.openOrderData.filter(o => {
				return mapped.includes(o.orderno);
			});

			this.openorders = new MatTableDataSource(this.openorders);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;

		} else {
			this.openOrderData = this.allopenOrderData
			this.openorders = new MatTableDataSource(this.allopenOrderData);
			this.openorders.sort = this.sort;
			this.openorders.paginator = this.paginator;
		}

	}

	onInput(event: any) {
		if (this.openOrderData) {
			this.openorders = this.globalSearchService.filterItem(this.openOrderData, event, 'orderno,transno,ponumber,debtorno,deliverto,deliverydate');
		}
	}

	viewOrder(orderno: any, content: any) {

		this.creditService.getOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	loadOrder(tran: any) {
		const id = tran.invoiceid;	
		this.router.navigate(['/receivables/credit-invoice/' + id]);
		this.cart_updated.emit(id);
	}

	loadData() {
		this.dataLoadSub?.unsubscribe();
		this.dataLoadSub = null;

		let search = '';
		let load$: any = null;

		if (this.customerdata && this.customerdata.debtorno) {
			if (this.customerdata.debtorno) {
				search = this.customerdata.debtorno;
			}
			if (this.customerdata && search === '') {
				search = this.customerdata.customer.debtorno;
			}
			load$ = this.creditService.getCustomerOpenOrders(search);
		} else if (this.item) {
			search = this.item;
			load$ = this.creditService.getCustomerOpenOrdersByItem(search);
		} else if (!this.item && !this.customerdata) {
			load$ = this.creditService.getCustomerOpenOrders([]);
		}

		if (!load$) {
			return;
		}

		this.dataLoadSub = load$
			.pipe(takeUntil(this.destroy$))
			.subscribe((results: any) => {
				this.openOrderData = results;
				this.allopenOrderData = results;
				if (results) {
					this.credit_data.emit(results);
					this.openorders = new MatTableDataSource(results);
					this.openorders.sort = this.sort;
					this.openorders.paginator = this.paginator;
				}
			});
	}

	cancelOrder(orderno: any) {
		this.creditService.cancelOrder(orderno).subscribe(async (results: any) => {
			this.cancel.emit(true);
			this.cart_updated.emit(results);
			this.credit_data.emit(results);
			this.loadData()
		})
	}

	setDelivered(orderno: any) {
		this.creditService.setDelivered({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	updatePick(orderno: any) {
		//needs callback to have customer only
		this.creditService.updateOrderToPicked({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	back(): void {
		this.location.back()
	}

	ngOnChanges(changes: any): void{
		this.loadData();

		if(changes.lookingfor){
			if(changes.lookingfor.currentValue.length){
				this.orderMatches = changes.lookingfor.currentValue.map((ord) => {
					return ord['orderno'];
				})
			}else{
				this.orderMatches = [];
			}

		}
	}

	toggleEdit(tran: any) {
		if (!tran.edit) {
			tran.edit = true;
			this.order_status_edit.setValue(tran.orderstatusid);
		} else {
			tran.edit = false;
		}
	}
	exportToXLS() {

	}

	exportToPDF() {

	}
	saveStatusUpdate(tran: any) {

		const data = {
			trans: tran,
			type: this.order_status_edit.value,
			user: this.user,
		}

		this.creditService.updateOrderStatus(data).subscribe((r: any) => {
			if (r.success) {
				tran.edit = false;
				const status = this.order_statuses.filter(s => {
					return s.order_status_id == data.type;
				})[0];
				tran.statusname = status.name;
				tran.details.orderstatusid = data.type;
				this.order_status_edit.reset();

				this.loadData();

			}
		})
	}

	announceSortChange(sortState: Sort) {

	}

	usePrintConnect(){
		const ep = this.usersService.usePrintConnect();
		return ep;
	}

	printCustomerCopy(orderid){
		
		this.creditService.printCustomerCredit(orderid).subscribe((res: any) => {
			const type = 'CREDIT';
			const user = this.user.user.userid;
			const printers = this.usersService.getDevicesByType(user, type);
			if (printers && printers.length && res.base64.length) {
				this.omsService.setNewOrder();
				const rma = res['base64'][0];
				const data = { pdf: rma, user: user, devices: printers }	
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			}
		});
	}

}
